import React from "react";
import Headline from "./Headline";
import ContactAgents from "../../components/shared/ContactAgents";
import HomeLink from "../../widgets/HomeLink";

const bannerPath = '/iceholidays-assets/images/contact_agents_st_cover.png';
const breadcrumbs = [
  { title: <HomeLink/>},
  { title: 'Contact Agents' }
] 

class ContactAgentsPage extends React.Component {

  componentDidMount(): void {
    
  }
  

  render(){
    return (
      <div id="contact-agents-page">
        <Headline bannerImage={bannerPath} breadcrumbs={breadcrumbs} title="CONTACT AGENTS"/>

        <ContactAgents type="Signature"/>
      </div>
    )
  }
}

export default ContactAgentsPage;